import { ICorporateDataTableProps } from '@/creditflowresearch/ui/components/deals/DealListTable/components/CorporateDataTable';

import styles from '@/creditflowresearch/ui/components/deals/DealListTable/components/DealMobileCard/dealMobileCard.module.scss';

export const DealMobileCard = (props: ICorporateDataTableProps) => {
  const { columns, data } = props;
  return (
    <div className={ styles.container }>
      <div className={ styles.title }>Deal Details</div>
      <div className={ styles.content }>
        { columns.map((column) => (
          column.name !== 'upsized' && (
            <div key={ column.name } className={ styles.row }>
              <div className={ styles.label }>
                { column.title }
              </div>
              <div className={ styles.value }>
                { column.cellCallback ? column.cellCallback({
                  row: data[0],
                  cellData: undefined,
                  cellName: '',
                  rowIndex: 0,
                  isExpanded: false,
                  isHovered: false,
                }) : data[0][column.name] }
              </div>
            </div>
          )
        )) }
      </div>
    </div>
  );
};
